import { render, staticRenderFns } from "./ManageQuestion.vue?vue&type=template&id=379a8758&scoped=true"
import script from "./ManageQuestion.vue?vue&type=script&lang=js"
export * from "./ManageQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379a8758",
  null
  
)

export default component.exports